import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";

const initialState = {
  isSaved: false,
  saveOrRemoveSuccess: false,
  savingOrRemoving: false,
  saveOrRemoveFailure: false,
  lastSavedCaseExampleId: '', 
};

export const caseExamplesSaveSlice = createSlice({
  name: "caseExamplesSave",
  initialState,
  reducers: {
    setSavingOrRemoing: (state) => ({
      ...initialState,
      savingOrRemoving: true,
    }),
    setSaveOrRemoveFailure: (state) => ({
      ...state,
      savingOrRemoving: false,
      saveOrRemoveFailure: true,
    }),
    setSaveOrRemoveSuccess: (state) => ({
      ...state,
      savingOrRemoving: false,
      saveOrRemoveSuccess: true,
    }),
    setIsSaved: (state, action) => ({
      ...state,
      isSaved: action.payload,
    }),
    setLastSavedCaseExample: (state, action) => ({
      ...state,
      lastSavedCaseExampleId: action.payload,
    }),
    resetCaseExampleSave: () => ({
      ...initialState
    })
  },
});

export const { 
  setSavingOrRemoing,
  setSaveOrRemoveFailure,
  setSaveOrRemoveSuccess,
  setIsSaved,
  setLastSavedCaseExample,
  resetCaseExampleSave,
} = caseExamplesSaveSlice.actions;

export const saveCaseExample = (caseExampleId) => (dispatch) => {
  dispatch(setSavingOrRemoing());
  const apiPath =  `${Constants.API.CASE_EXAMPLES}/${caseExampleId}${Constants.API.SAVE}`;
  apiService.post(apiPath).then((response) => {
    dispatch(setIsSaved(response?.data?.data?.isSaved));
    dispatch(setLastSavedCaseExample(caseExampleId));
    dispatch(setSaveOrRemoveSuccess());
  }).catch(() => {
    dispatch(setSaveOrRemoveFailure());
  })
};

export const removeCaseExample = (caseExampleId) => (dispatch) => {
  dispatch(setSavingOrRemoing());
  const apiPath =  `${Constants.API.CASE_EXAMPLES}/${caseExampleId}${Constants.API.SAVE}`;
  apiService.delete(apiPath).then((response) => {
    dispatch(setIsSaved(response?.data?.data?.isSaved));
    dispatch(setLastSavedCaseExample(caseExampleId));
    dispatch(setSaveOrRemoveSuccess());
  }).catch(() => {
    dispatch(setSaveOrRemoveFailure());
  })
};

export default caseExamplesSaveSlice.reducer;
